/**
 * FlahaSOIL v2 — Chart unit constants (Phase 10C-D).
 */

export const CHART_UNITS = {
  percent: "%",
  volPercent: "% v/v",
  density: "g/cm³",
  conductivity: "mm/h",
  cec: "cmol(+)/kg",
  ec: "dS/m",
  temperature: "°C",
  unitless: "",
} as const;
